import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a href="https://www.bosscarsoft.com/" rel="noopener noreferrer"  target="_blank">
          BossCarSoft
        </a> &copy; 2018-2022 v1.2.24 2022-09-30 21:44


        <span className="float-right">Powered by
          <a href="https://www.appxar.co" rel="noopener noreferrer"  target="_blank">&nbsp;Apzar Solution Co.,Ltd.</a>
        </span>

      </footer>
    )
  }
}

export default Footer;
